/* Application map facade. All rendering and controls are supplied by AMap JS API 2.0. */
const sdk = () => {
  if (!window.AMap) throw new Error('高德地图加载失败，请检查网络后刷新页面');
  return window.AMap;
};
class LatLng {
  constructor(lat, lng) { this.lat = Number(lat); this.lng = Number(lng); }
  getLat() { return this.lat; }
  getLng() { return this.lng; }
}
const xy = p => [Number(p.lng), Number(p.lat)];
class LatLngBounds {
  constructor() { this.points = []; }
  extend(p) { this.points.push(p); return this; }
}
class MapView {
  constructor(container, options = {}) {
    const A = sdk();
    this.native = new A.Map(container, { ...options, center: options.center ? xy(options.center) : [110.85, 21.92], viewMode: '2D' });
    this.native.addControl(new A.Scale());
    this.native.addControl(new A.ToolBar());
    this.layers = [];
    Object.preventExtensions(this); // Do not let Vue 2 recursively observe SDK internals.
  }
  setCenter(p) { this.native.setCenter(xy(p)); }
  getCenter() { const p = this.native.getCenter(); return new LatLng(p.lat, p.lng); }
  fitBounds(bounds) {
    if (!bounds.points.length) return;
    const xs = bounds.points.map(p => p.lng), ys = bounds.points.map(p => p.lat);
    const A = sdk();
    this.native.setBounds(new A.Bounds([Math.min(...xs), Math.min(...ys)], [Math.max(...xs), Math.max(...ys)]));
  }
  on(name, handler) { this.native.on(name, handler); }
  destroy() { this.layers.forEach(layer => layer.setGeometries([])); this.native.destroy(); }
}
class Style { constructor(options) { Object.assign(this, options); } }
class Layer {
  constructor(options, kind) {
    this.map = options.map; this.styles = options.styles || {}; this.kind = kind;
    this.items = new Map(); this.handlers = {};
    this.map.layers.push(this);
    this.updateGeometries(options.geometries || []);
    Object.preventExtensions(this);
  }
  setGeometries(items) {
    this.items.forEach(item => item.overlay.setMap(null)); this.items.clear();
    this.updateGeometries(items);
  }
  updateGeometries(items) {
    const A = sdk();
    items.forEach((geometry, index) => {
      const id = geometry.id == null ? String(index) : geometry.id;
      const old = this.items.get(id); if (old) old.overlay.setMap(null);
      const style = this.styles[geometry.styleId] || {};
      let overlay;
      if (this.kind === 'marker') {
        if (!geometry.position) return;
        const options = { position: xy(geometry.position), anchor: 'bottom-center', extData: geometry };
        if (style.src) options.icon = new A.Icon({ image: style.src, size: new A.Size(style.width || 25, style.height || 35), imageSize: new A.Size(style.width || 25, style.height || 35) });
        overlay = new A.Marker(options);
        overlay.on('click', event => (this.handlers.click || []).forEach(fn => fn({ ...event, geometry })));
      } else {
        overlay = new A.Polyline({ path: (geometry.paths || []).map(xy), strokeColor: style.color || '#3777FF', strokeWeight: style.width || 6, isOutline: Boolean(style.borderWidth), outlineColor: style.borderColor || '#fff', borderWeight: style.borderWidth || 0, showDir: Boolean(style.showArrow), lineJoin: 'round', lineCap: 'round' });
      }
      overlay.setMap(this.map.native); this.items.set(id, { geometry, overlay });
    });
  }
  on(name, handler) { this.handlers[name] = [...(this.handlers[name] || []), handler]; }
}
class MultiMarker extends Layer { constructor(options) { super(options, 'marker'); } }
class MultiPolyline extends Layer { constructor(options) { super(options, 'line'); } }
// Web geolocation is WGS84. Request AMap's GCJ-02 result before storing/order matching.
function getCurrentPosition(success, failure) {
  try {
    const A = sdk();
    const geo = new A.Geolocation({ enableHighAccuracy: true, timeout: 10000, convert: true });
    geo.getCurrentPosition((status, result) => {
      if (status === 'complete' && result.position) success({ coords: { latitude: result.position.lat, longitude: result.position.lng, accuracy: result.accuracy }, timestamp: Date.now() });
      else if (failure) failure({ code: 2, message: '高德定位失败，请检查定位权限', POSITION_UNAVAILABLE: 2 });
    });
  } catch (error) { if (failure) failure(error); }
}
const watches = new Map(); let watchId = 0;
function watchPosition(success, failure) {
  const id = ++watchId; let active = true; let busy = false;
  const poll = () => { if (busy || !active) return; busy = true; getCurrentPosition(p => { busy = false; if (active) success(p); }, e => { busy = false; if (active && failure) failure(e); }); };
  poll(); const timer = setInterval(poll, 10000);
  watches.set(id, () => { active = false; clearInterval(timer); }); return id;
}
function clearWatch(id) { if (watches.has(id)) watches.get(id)(); watches.delete(id); }
function navigationUrl(lat, lng, name) {
  if (lat == null || lng == null || !Number.isFinite(Number(lat)) || !Number.isFinite(Number(lng))) throw new Error('缺少导航坐标');
  return `https://uri.amap.com/navigation?to=${Number(lng)},${Number(lat)},${encodeURIComponent(name || '目的地')}&mode=car&coordinate=gaode&callnative=1&src=乘风快购`;
}
window.MapKit = { Map: MapView, LatLng, LatLngBounds, MarkerStyle: Style, PolylineStyle: Style, MultiMarker, MultiPolyline, getCurrentPosition, watchPosition, clearWatch, navigationUrl };
export default window.MapKit;
